export const getPixImageSource = (encodedImage) => {
  if (!encodedImage) return null
  if (String(encodedImage).startsWith("data:image/")) return encodedImage
  return `data:image/png;base64,${encodedImage}`
}
